import React from 'react'
import RequestSelectedUserData from 'redesign/components/atoms/Buttons/request-selected-users-data-button'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import RequestUserDataContent from 'redesign/components/templates/request-user-data-content'
import ConfirmRequestUserDataPage from './confirm-request-user-data-page'
import { useRequestUserData } from './use-request-user-data'

const RequestUserDataPage: React.FC = () => {
  const {
    loading,
    t,
    palette,
    employeeSearchProps,
    tenantSelectRadioProps,
    showTenantSelect,
    showConfirmForm,
    requestedUsersAmount,
    setShowConfirmForm,
  } = useRequestUserData()

  if (showConfirmForm) {
    return (
      <ConfirmRequestUserDataPage setShowConfirmForm={setShowConfirmForm} requestedUsersAmount={requestedUsersAmount} />
    )
  }

  return (
    <Page
      header={<HeaderWithBackButton title={t('requestEmployeeData.common.overTitle')} />}
      removeLastMargin
      hideNativeNavigation
      fullContentHeight
      backgroundColor={palette.background.base}
      footer={
        <RequestSelectedUserData onClick={() => setShowConfirmForm(true)} requestedUsersAmount={requestedUsersAmount} />
      }
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <RequestUserDataContent
          tenantSelectRadioProps={tenantSelectRadioProps}
          employeeSearchProps={employeeSearchProps}
          showTenantSelect={showTenantSelect}
        />
      )}
    </Page>
  )
}

export default RequestUserDataPage
